(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hrny-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hrny-delivery-estimate')) {
  customElements.define('hrny-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.ready = true;
      const refresh = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        const total = this.querySelector('.hrny-delivery-total');
        total.hidden = !available;
        total.textContent = available ? option.dataset.total : '';
        this.querySelector('.hrny-delivery-unavailable').hidden = available;
        this.querySelector('.hrny-delivery-timing').hidden = !available;
        this.querySelector('.hrny-delivery-transit').textContent = available ? option.dataset.transit : '';
        this.querySelector('.hrny-delivery-destination').textContent = option.dataset.destination;
        this.dataset.country = select.value;
      };
      try {
        const saved = sessionStorage.getItem('hrny-delivery-destination');
        if (saved && Array.from(select.options).some(option => option.value === saved)) select.value = saved;
      } catch (_) {}
      refresh();
      select.addEventListener('change', () => {
        refresh();
        try { sessionStorage.setItem('hrny-delivery-destination', select.value); } catch (_) {}
      });
      this.querySelector('.hrny-delivery-country').hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
